import { render } from "./DeviceChangeRequests.vue?vue&type=template&id=a4c00d9c"
import script from "./DeviceChangeRequests.vue?vue&type=script&lang=js"
export * from "./DeviceChangeRequests.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__